import React, { useState } from "react";

import Select from "react-select";
import { setOrderStatus } from "../../store/actions/RestaurantActions";
import { connect } from "react-redux";

const OrderStatusSelector = ({
  selected,
  restaurantId,
  orderId,
  selectStatus,
  userId,
}) => {
  const [selectedValue, setSelectedValue] = useState(selected);

  const options = [
    { value: "aceptada", label: "Aceptada" },
    { value: "en curso", label: "En curso" },
    { value: "cancelada", label: "Cancelada" },
    { value: "completada", label: "Completada" },
    { value: "solicitada", label: "Solicitada" },
  ];

  const select = (obj) => {
    setSelectedValue(obj.value);
    selectStatus(restaurantId, obj.value, orderId, userId);
  };

  return (
    <Select
      options={options}
      value={options.filter((option) => option.value === selectedValue)}
      onChange={select}
    />
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    selectStatus: (restaurantId, status, orderId, userId) =>
      dispatch(setOrderStatus(restaurantId, status, orderId, userId)),
  };
};

export default connect(null, mapDispatchToProps)(OrderStatusSelector);
